import leadConversionsAnalyticsService from 'services/lead-conversions-analytics-service'

// ------------------------------------
// Constants
// ------------------------------------
let LOAD_LEAD_DISTRIBUTION_ANALYTICS = 'LOAD_LEAD_DISTRIBUTION_ANALYTICS'

export function loadLeadDistributionAnalytics(filter, statusField) {
  return (dispatch, getState) => {
    return leadConversionsAnalyticsService.getLeadDistributions(filter, statusField)
      .then((leadDistributions) => {
        dispatch({
          type: LOAD_LEAD_DISTRIBUTION_ANALYTICS,
          leadDistributions: leadDistributions
        })
      })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

export function leadDistributionAnalyticsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_LEAD_DISTRIBUTION_ANALYTICS: {
      return action.leadDistributions
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/LeadDistributionAnalytics/modules/LeadDistributionAnalytics.js